'use client';
import type { Assign } from '@ark-ui/react';
import { ToggleGroup } from '@ark-ui/react';
import {
  type ToggleGroupVariantProps,
  toggleGroup,
} from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(toggleGroup);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, ToggleGroup.RootProviderProps>,
    ToggleGroupVariantProps
  >
>(ToggleGroup.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, ToggleGroup.RootProps>,
    ToggleGroupVariantProps
  >
>(ToggleGroup.Root, 'root');

export const Item = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, ToggleGroup.ItemProps>
>(ToggleGroup.Item, 'item');

export { ToggleGroupContext as Context } from '@ark-ui/react';
